import { useCallback } from 'react';

import { Button } from 'src/common/primitives/Button';
import { TilledLogo } from 'src/common/primitives/logos/TilledLogo';

import { launchApplicationPopup } from '../helpers/launchApplicationPopup';

export function ContinueTilledMerchantApplication({
  onboardingUrl,
}: {
  onboardingUrl: string;
}) {
  const handleContinueMerchantApplication = useCallback(() => {
    // Launch tilled application flow
    launchApplicationPopup(onboardingUrl);
  }, [onboardingUrl]);

  return (
    <>
      <div
        data-testid="continue-tilled-merchant-application"
        className="flex flex-grow flex-row items-center gap-2"
      >
        <TilledLogo />
        <div>Continue your merchant account application.</div>
      </div>
      <div>
        <Button onClick={handleContinueMerchantApplication}>Continue</Button>
      </div>
    </>
  );
}
